import axiosInstance from 'shared/services/api/axiosInstance';

/**
 * Plain one-shot fetch of distinct values, for callers that want a flat list
 * (e.g. a dropdown with a handful of span names). The filter chips do not use
 * this: they load through shared/utils/filters/propertyCatalogStore (cached,
 * deduped, paged on open and on search).
 */

/** Default page for a one-shot fetch. */
export const FILTER_PROPERTY_VALUE_LIMIT = 100;

/**
 * Fetch distinct values for an agent-runs filter field.
 * Pass `q` for server-side substring search (ILIKE), `offset` to page.
 */
export async function fetchAgentRunPropertyValues({
  teamId,
  field,
  agentName,
  q,
  limit = FILTER_PROPERTY_VALUE_LIMIT,
  offset = 0,
  signal,
}) {
  if (!teamId || !field) return [];
  const params = { team_id: teamId, field, limit };
  if (offset) params.offset = offset;
  if (agentName) params.agent_name = agentName;
  const trimmed = String(q || '').trim();
  if (trimmed) params.q = trimmed;
  const { data } = await axiosInstance.get('/agent-runs/property-values', { params, signal });
  return data?.values || [];
}
